import React, { useState, useEffect, useRef } from "react";
import "./EvenementsContainer.scss";
import Evenement from "../EvenementCard/EvenementCard";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { FaChevronRight } from "react-icons/fa";
import PropTypes from "prop-types";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Accordion, AccordionTab } from "primereact/accordion";
import { formatDateDatabase, formatDateFrenchLocale } from "Services/functions";
import { updateEvents } from "Redux/Actions/eventsActions";
import { useFetchGet, useFetchGetPagination } from "Services/api";
import { updateMenu } from "Redux/Actions/menuActions";
import { registerLocale } from "react-datepicker";
import { fr } from "date-fns/locale";
import TempPagination from "Components/Pagination/TempPagination";
import Loader from "Components/Loader/loader";
import ModalConnexion from "Components/Modal/ModalConnexion/ModalConnexion";
import Filters from "Components/Filters/Filters";
registerLocale("fr", fr);

const EvenementsContainer = (props) => {
  const [loginVisible, setLoginVisible] = useState(false);

  const evenementContainerRef = useRef(null);
  const categoriesData = useFetchGet(
    props.pageEvents === "accueil" ? null : "/event_categories",
    props.auth.token
  );
  const [categories, setCategories] = useState([]);
  const [filtreCategory, setFiltreCategory] = useState(null);
  const [filtreMotsCles, setFiltreMotsCles] = useState("");
  const [filtreDate, setFiltreDate] = useState(null);
  const [isKeywordFiltering, setIsKeywordFiltering] = useState(false);
  const [eventsUrl, setEventsUrl] = useState(props.queryUrl ?? null);

  const eventsQuery = useFetchGetPagination(
    eventsUrl,
    props.auth.token,
    props.handleUpdateEvents
  );

  useEffect(() => {
    if (props.queryUrl && props.queryUrl !== eventsUrl) {
      setEventsUrl(props.queryUrl);
    }
  }, [props.queryUrl]);

  useEffect(() => {
    return () => {
      props.handleUpdateEvents({
        dataFromPagination: null,
      });
    };
  }, []);

  useEffect(() => {
    /// Récupérer les catégories, et les filtrer par ordre alphabétique
    if (categoriesData?.loaded) {
      setCategories([]);
      let tempArray = [];
      categoriesData?.data.forEach((category) => tempArray.push(category));
      tempArray = tempArray.sort((a, b) => a.label.localeCompare(b.label));
      setCategories(tempArray);
    }
  }, [categoriesData?.loaded]);

  const handleFilter = () => {
    if (props.states.statesData.length > 0) {
      let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/events`);
      url.searchParams.set(
        "state",
        props.states.statesData.filter(
          (etat) => etat.statusLabel === "Publié"
        )[0].id
      );
      url.searchParams.set("endingAt[after]", formatDateDatabase(new Date()));
      url.searchParams.set("order[startingAt]", "asc");
      if (filtreMotsCles != "") url.searchParams.set("keyword", filtreMotsCles);
      if (filtreCategory) url.searchParams.set("category", filtreCategory.id);
      if (filtreDate && filtreDate[0])
        url.searchParams.set(
          "startingAt[after]",
          formatDateDatabase(filtreDate[0])
        );
      if (filtreDate && filtreDate[1])
        url.searchParams.set(
          "endingAt[before]",
          formatDateDatabase(filtreDate[1])
        );
      props.nbEvents && url.searchParams.set("itemsPerPage", props.nbEvents);
      setEventsUrl(url);
    }
  };

  useEffect(() => {
    if (
      (!filtreDate || (filtreDate[0] && filtreDate[1])) &&
      (!props.queryUrl || props.nbEvents === 12)
    ) {
      handleFilter();
    }
  }, [
    filtreCategory,
    filtreDate,
    isKeywordFiltering,
    props.states.statesData.length,
  ]);

  return (
    <div className="evenements_container">
      <div className="evenements_all">
        <div className="evenements_container__top">
          {props.pageEvents == "accueil" ? (
            // si on est dans la page d'accueil on n'affiche pas les filtres
            <div className="evenements_container__top__title">
              <h1 className="h1_trait_dessus">
                {props.title ? props.title : "Les événements"}
              </h1>
            </div>
          ) : (
            <div>
              {/* si on est sur la page Evenements on affiche les filtres */}
              <div className="evenements_container__top__title">
                <h1 className="h1_trait_dessus">
                  {props.title ? props.title : "Tous les événements"}
                </h1>
                <div className="evenements_container__top__title__visible">
                  <div className="evenements_container__top__title__filtres">
                    <Filters
                      filtreMotsCles={filtreMotsCles}
                      setFiltreMotsCles={setFiltreMotsCles}
                      filtreDate={filtreDate}
                      setFiltreDate={setFiltreDate}
                      filtreDropdown={filtreCategory}
                      setFiltreDropdown={setFiltreCategory}
                      dataDropdown={categories}
                      setIsKeywordFiltering={setIsKeywordFiltering}
                      filterFunction={handleFilter}
                    ></Filters>
                    {props.auth.isConnected && (
                      <Link to="/profil">
                        <div>
                          <BtnBlanc
                            btnTexte="Mes événements à venir"
                            btnAction={() => {
                              props.handleUpdateMenu({
                                activeItemProfil:
                                  props.items.itemsProfil.findIndex(
                                    (v) => v.label == "Mes événements à venir"
                                  ),
                              });
                            }}
                          />
                        </div>
                      </Link>
                    )}
                  </div>
                </div>
                <Accordion
                  className="accordion_events"
                  expandIcon="pi pi-sliders-h"
                  collapseIcon="pi pi-sliders-h"
                >
                  <AccordionTab header="Filtres de recherche">
                    <div className="evenements_container__top__title__filtres">
                      <Filters
                        filtreMotsCles={filtreMotsCles}
                        setFiltreMotsCles={setFiltreMotsCles}
                        filtreDate={filtreDate}
                        setFiltreDate={setFiltreDate}
                        filtreDropdown={filtreCategory}
                        setFiltreDropdown={setFiltreCategory}
                        dataDropdown={categories}
                        setIsKeywordFiltering={setIsKeywordFiltering}
                        filterFunction={handleFilter}
                      ></Filters>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
            </div>
          )}
        </div>

        <div className="evenements_container__body" ref={evenementContainerRef}>
          {eventsQuery?.data ? (
            eventsQuery.data.length > 0 ? (
              (props.nbEvents && props.nbEvents != 20
                ? eventsQuery.data.slice(0, props.nbEvents)
                : eventsQuery.data
              ).map((event, index) =>
                props.auth.userConnected || event.public ? (
                  <Link
                    to={{
                      pathname: `/event-detail/${event.id}`,
                      params: event.id,
                    }}
                    key={index}
                  >
                    <Evenement
                      key={index}
                      categorie={
                        event.eventCategoryLabel
                          ? { label: event.eventCategoryLabel }
                          : event.category
                      }
                      inscription={event.fulfilled}
                      debutDate={
                        "Du " +
                        formatDateFrenchLocale(
                          event.startingAt?.date || event.startingAt
                        )
                      }
                      finDate={
                        "Au " +
                        formatDateFrenchLocale(
                          event.endingAt?.date || event.endingAt
                        )
                      }
                      title={event.title}
                      chapeau={event.description}
                      eventDetails={event}
                      url={event?.imageUrl || event.nexusImageUrl || "event1"}
                      nexusUrl={event?.nexusImageUrl}
                      registerEnd={event.registerEnd?.date || event.registerEnd}
                    />
                  </Link>
                ) : (
                  <Evenement
                      key={index}
                    categorie={
                      event.eventCategoryLabel
                        ? { label: event.eventCategoryLabel }
                        : event.category
                    }
                    inscription={event.fulfilled}
                    debutDate={
                      "Du " +
                      formatDateFrenchLocale(
                        event.startingAt?.date || event.startingAt
                      )
                    }
                    finDate={
                      "Au " +
                      formatDateFrenchLocale(
                        event.endingAt?.date || event.endingAt
                      )
                    }
                    title={event.title}
                    chapeau={event.description}
                    eventDetails={event}
                    url={event?.imageUrl || event.nexusImageUrl || "event1"}
                    nexusUrl={event?.nexusImageUrl}
                    onClick={() => {
                      setLoginVisible(true);
                    }}
                    registerEnd={event.registerEnd?.date || event.registerEnd}
                  />
                )
              )
            ) : (
              <div
                className="
              evenements_container__body-empty
              "
              >
                <span>Aucun événement ne correspond à votre recherche</span>
              </div>
            )
          ) : (
            <Loader></Loader>
          )}
        </div>
        {loginVisible && (
          <ModalConnexion
            setVisibleModal={setLoginVisible}
            visibleModal={loginVisible}
          />
        )}
        <div className="evenements_container__button">
          {props.pageEvents == "accueil" ? (
            <BtnBleu
              btnTexte="Voir tous les événements"
              btnAction={() => (window.location.href = "./evenements")}
            >
              <FaChevronRight />
            </BtnBleu>
          ) : (
            <TempPagination
              result={eventsQuery}
              refItemParent={evenementContainerRef}
              rows={50}
            />
          )}
        </div>
      </div>
    </div>
  );
};

EvenementsContainer.propTypes = {
  auth: PropTypes.object,
  nbEvents: PropTypes.number,
  pageEvents: PropTypes.string,
  events: PropTypes.any,
  title: PropTypes.string,
  handleUpdateEvents: PropTypes.func,
  items: PropTypes.object,
  handleUpdateMenu: PropTypes.func,
  states: PropTypes.object,
  queryUrl: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  events: state.events,
  pagination: state.pagination,
  items: state.items,
  states: state.states,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateEvents: (value) => {
    dispatch(updateEvents(value));
  },
  handleUpdateMenu: (value) => dispatch(updateMenu(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvenementsContainer);
